import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {saveBlob} from '../../utils/save-blob';
import {BlobDownloadService} from '../blob-download.service';

@Injectable({
    providedIn: 'root'
})
export class BlobDownloadServiceMock implements BlobDownloadService {
    protected http = inject(HttpClient);


    async saveBlob(url: string, fileName: string): Promise<void> {
        saveBlob(new Blob(['testje'], {type: 'text/plain'}), fileName);
    }
}
